<template>
    <div class="com-right-content text-white">
        <div>
            <BlockBox title="参与总览" enTitle="Participation Overview" height="326">
                <template #content>
                    <div style="padding:10px 15px;box-sizing: border-box">
                        <div class="overviewGrid">
                            <div class="overviewItem" v-for="(item, index) in overviewData" :key="index">
                                <!-- <div class="overviewIcon">
                                    <img src="../../../assets/img/dz001.png">
                                </div> -->
                                <div class="overviewInfo">
                                    <div class="overviewNum" :class="getColorClass(index)">{{item.value}}</div>
                                    <div class="overviewLabel">{{item.label}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
        
        <div class="margin-top-15">
            <BlockBox title="指标巅峰榜" enTitle="Indicator Peak Chart" height="630" titleType="right">
                <template #titleLabel>
                    <div class="indicatorTabs">
                        <span class="tabItem" :class="{active: activeTab === 'works'}" @click="switchTab('works')">作品成果</span>
                    </div>
                </template>
                <template #content>
                    <div style="padding:10px 15px;box-sizing: border-box">
                        <div class="peakContent">
                            <div class="worksLayout">
                                <div class="worksSchoolList">
                                    <div class="schoolHeader">
                                        <div class="col-school">学校名称</div>
                                        <div class="col-count">累计作品数</div>
                                    </div>
                                    <div class="schoolBody">
                                        <div class="schoolRow" 
                                             v-for="(row, index) in worksData" 
                                             :key="index"

                                             @click="selectSchool(index)">
                                            <div class="col-school ellipsis">{{row.name}}</div>
                                            <div class="col-count">{{row.value}}</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </template>
            </BlockBox>
        </div>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    import BlockBox from '@/views/components/blockBox'
    import { cityRightData } from "@/api/api";
    
    export default {
        name: "cityRightContent",
        components: {
            BlockBox
        },
        data() {
            return {
                item: {},
                activeTab: 'works',
                overviewData: [
                    { value: 1384, label: '参与学生数' },
                    { value: 72, label: '参与家长数' },
                    { value: 107, label: '参与教师数' },
                    { value: 5, label: '参与学校数' },
                    { value: 16, label: '活动任务' },
                    { value: 3, label: '作品成果' },
                    { value: 3, label: '活动评价' },
                    { value: 23530, label: '参与人次' },
                ],
                worksData: [
                    { schoolName: '启东市南苑中学', totalCount: 0 },
                    { schoolName: '启东市南苑小学', totalCount: 3 },
                    { schoolName: '启东市开发区中学', totalCount: 0 },
                    { schoolName: '启东市蝶湖中学', totalCount: 0 },
                    { schoolName: '启东市蝶湖小学', totalCount: 0 },
                ],
                selectedSchoolIndex: 0,
                indicatorData: [
                    { name: '乐活', value: 0, maxValue: 10 },
                    { name: '健体', value: 0, maxValue: 10 },
                    { name: '创新作品', value: 2, maxValue: 10 },
                    { name: '力行', value: 0, maxValue: 10 },
                    { name: '勤创', value: 0, maxValue: 10 },
                    { name: '善学', value: 0, maxValue: 10 },
                    { name: '学科', value: 0, maxValue: 10 },
                    { name: '崇美', value: 0, maxValue: 10 },
                    { name: '慧学', value: 0, maxValue: 10 },
                    { name: '拓新', value: 0, maxValue: 10 },
                    { name: '明德', value: 0, maxValue: 10 },
                    { name: '美观汉字', value: 1, maxValue: 10 },
                    { name: '运动习惯', value: 0, maxValue: 10 },
                ],
                activityData: [
                    { activityName: '上传更多创新作品', participationCount: 2 },
                    { activityName: '上传书法课堂作品', participationCount: 1 },
                ],
                activityPieData: [
                    { value: 3, name: '启东市南苑小学' },
                ],
                activityChart: null,
                timerRight: null,
            }
        },
        mounted() {
            this.changeData();
            this.timerRight = setTimeout(() => {
                this.changeData();
            }, 60000);
        },
        beforeDestroy() {
            clearTimeout(this.timerRight);
            if (this.activityChart) {
                this.activityChart.dispose();
            }
        },
        methods: {
            async changeData() {
                try {
                    const res = await cityRightData();
                    if (res && res.data) {
                        this.item = res.data;

                      this.overviewData=[];
                      this.overviewData.push({ value: this.item.studentCount, label: '参与学生数' });
                      this.overviewData.push({ value: this.item.memberCount, label: '参与家长数' });
                      this.overviewData.push({ value: this.item.teacherCount, label: '参与教师数' });
                      this.overviewData.push({ value: this.item.schoolCount, label: '参与学校数' });
                      this.overviewData.push({ value: this.item.taskCount, label: '活动任务' });
                      this.overviewData.push({ value: this.item.taskRecordCount, label: '作品成果' });
                      this.overviewData.push({ value: this.item.recordCount, label: '教师评价次' });
                      this.overviewData.push({ value: this.item.qualityCount, label: '素质报告' });

                        if (res.data.overviewData) {
                            this.overviewData = res.data.overviewData;
                        }
                        if (res.data.list) {
                            this.worksData = res.data.list;
                        }
                        if (res.data.indicatorData) {
                            this.indicatorData = res.data.indicatorData;
                        }
                        if (res.data.activityData) {
                            this.activityData = res.data.activityData;
                        }
                        if (res.data.activityPieData) {
                            this.activityPieData = res.data.activityPieData;
                        }
                    }
                } catch (e) {
                    console.log('使用默认数据');
                }
            },
            switchTab(tab) {
                this.activeTab = tab;
                if (tab === 'activity') {
                    this.$nextTick(() => {
                        this.drawActivityPie();
                    });
                }
            },
            selectSchool(index) {
                this.selectedSchoolIndex = index;
            },
            getIndicatorBarWidth(value, max) {
                if (max === 0) return 0;
                return (value / max) * 100;
            },
            drawActivityPie() {
                const chartDom = document.getElementById('chartActivityPie');
                if (!chartDom) return;
                
                if (this.activityChart) {
                    this.activityChart.dispose();
                }
                
                this.activityChart = echarts.init(chartDom);
                
                const option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c} ({d}%)'
                    },
                    series: [{
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 0,
                            borderColor: '#0a1e3c',
                            borderWidth: 2
                        },
                        label: {
                            show: true,
                            position: 'bottom',
                            formatter: '{b} {c} ({d}%)',
                            color: 'rgba(255,255,255,0.7)',
                            fontSize: 12
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.activityPieData,
                        color: ['#247bf1']
                    }]
                };
                
                this.activityChart.setOption(option);
                
                window.addEventListener('resize', () => {
                    if (this.activityChart) {
                        this.activityChart.resize();
                    }
                });
            },
            getIconByIndex(index) {
				console.log(index)
                return '';
            },
            getColorClass(index) {
                const colors = ['text-color-blue', 'text-color-green', 'text-color-orange', 'text-color-yellow'];
                return colors[index % colors.length];
            }
        }
    }
</script>

<style lang="scss">
    .com-right-content {
        min-height: 500px;
        padding: 14px 15px 15px 15px;
        box-sizing: border-box;

        .overviewGrid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 10px;
			padding-top:20px;

            .overviewItem {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 10px 5px;
                // background: linear-gradient(180deg, rgba(20, 60, 120, 0.4) 0%, rgba(10, 30, 60, 0.2) 100%);
                // border-radius: 8px;
                // border: 1px solid rgba(100, 180, 255, 0.2);
				background: url('../../../assets/img/dz001.png') top center;
				background-repeat: no-repeat;
				background-size: 100% auto;
				height: 120px;

                .overviewIcon {
                    width: 40px;
                    height: 40px;
                    margin-bottom: 8px;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                .overviewInfo {
                    text-align: center;

                    .overviewNum {
                        font-size: 24px;
                        font-weight: bold;
                        line-height: 1.2;
                    }

                    .overviewLabel {
                        font-size: 12px;
                        // color: rgba(160, 210, 255, 0.7);
						color: rgba(255, 255, 255, 0.9);
                        margin-top:45px;
						// font-weight: bold;
						
                    }
                }
            }
        }

        .indicatorTabs {
            display: flex;
            align-items: center;
            gap: 15px;
            padding-right: 10px;

            .tabItem {
                font-size: 16px;
                color: rgba(255, 255, 255, 0.5);
                cursor: pointer;
                padding: 4px 8px;
                transition: all 0.3s;

                &:hover {
                    color: rgba(255, 255, 255, 0.8);
                }

                &.active {
                    color: #fff;
                    font-weight: bold;
                }
            }
        }

        .peakContent {
            .worksLayout {
                display: flex;
                justify-content: space-between;

                .worksSchoolList {
                    flex: 1;
                    max-width: 98%;

                    .schoolHeader {
                        height: 36px;
                        background: rgba(20, 60, 120, 0.3);
                        border-radius: 4px;
                        font-weight: bold;
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.8);
                        padding: 0 10px;
                        display: flex;
                        align-items: center;

                        .col-school {
                            flex: 2;
                        }

                        .col-count {
                            flex: 1;
                            text-align: center;
                        }
                    }

                    .schoolBody {
                        max-height: 380px;
                        overflow-y: auto;

                        &::-webkit-scrollbar {
                            width: 3px;
                        }

                        &::-webkit-scrollbar-thumb {
                            background: rgba(45, 163, 255, 0.5);
                            border-radius: 3px;
                        }

                        .schoolRow {
                            height: 48px;
                            font-size: 14px;
                            border-bottom: 1px solid rgba(45, 163, 255, 0.08);
                            padding: 0 10px;
                            color: rgba(255, 255, 255, 0.7);
                            cursor: pointer;
                            transition: all 0.3s;
                            display: flex;
                            align-items: center;

                            .col-school {
                                flex: 2;
                            }

                            .col-count {
                                flex: 1;
                                text-align: center;
                                font-weight: bold;
                                font-size: 18px;
                            }

                            &.active {
                                background: rgba(20, 80, 160, 0.4);
                                color: #fff;
                                border-left: 3px solid #247bf1;
                            }

                            &:hover {
                                background: rgba(20, 60, 120, 0.3);
                            }
                        }
                    }
                }

                .worksIndicatorList {
                    flex: 1;
                    padding-left: 20px;

                    .indicatorRow {
                        height: 32px;
                        margin-bottom: 4px;
                        display: flex;
                        align-items: center;

                        .indicatorName {
                            width: 70px;
                            font-size: 13px;
                            color: rgba(255, 255, 255, 0.7);
                            text-align: right;
                            padding-right: 8px;
                            flex-shrink: 0;
                        }

                        .indicatorValue {
                            width: 18px;
                            font-size: 13px;
                            color: rgba(255, 255, 255, 0.8);
                            text-align: right;
                            flex-shrink: 0;
                        }

                        .indicatorBar {
                            flex: 1;
                            display: flex;
                            align-items: center;
                            padding-left: 5px;

                            .barLine {
                                width: 100%;
                                height: 1px;
                                background: rgba(255, 255, 255, 0.15);
                                position: relative;

                                .barFill {
                                    height: 14px;
                                    background: transparent;
                                    transition: width 0.5s ease;
                                    min-width: 0;
                                    position: absolute;
                                    left: 0;
                                    top: 50%;
                                    transform: translateY(-50%);

                                    &.hasValue {
                                        background: #247bf1;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .activityLayout {
                display: flex;
                justify-content: space-between;

                .activityList {
                    flex: 1;
                    max-width: 45%;

                    .activityHeader {
                        height: 36px;
                        background: rgba(20, 60, 120, 0.3);
                        border-radius: 4px;
                        font-weight: bold;
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.8);
                        padding: 0 10px;
                        display: flex;
                        align-items: center;

                        .col-name {
                            flex: 2;
                        }

                        .col-count {
                            flex: 1;
                            text-align: center;
                        }
                    }

                    .activityBody {
                        max-height: 380px;
                        overflow-y: auto;

                        &::-webkit-scrollbar {
                            width: 3px;
                        }

                        &::-webkit-scrollbar-thumb {
                            background: rgba(45, 163, 255, 0.5);
                            border-radius: 3px;
                        }

                        .activityRow {
                            height: 48px;
                            font-size: 14px;
                            border-bottom: 1px solid rgba(45, 163, 255, 0.08);
                            padding: 0 10px;
                            color: rgba(255, 255, 255, 0.7);
                            display: flex;
                            align-items: center;

                            .col-name {
                                flex: 2;
                            }

                            .col-count {
                                flex: 1;
                                text-align: center;
                                font-weight: bold;
                                font-size: 18px;
                            }

                            &:hover {
                                background: rgba(20, 60, 120, 0.3);
                            }
                        }
                    }
                }

                .activityChart {
                    flex: 1;
                    padding-left: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
</style>
